import './styles.css'
import { mount } from './ui/app'

mount()
